import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { setAttribute as _$setAttribute } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
import { use as _$use } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<p class=shell__notice>LOADING…`),
  _tmpl$2 = /*#__PURE__*/_$template(`<p class=shell__notice>The baked assets could not be loaded. Run <code>bun run bake</code> and reload.`),
  _tmpl$3 = /*#__PURE__*/_$template(`<main class=shell><canvas class=shell__screen>`);
/**
 * The DOM around a shell surface: one canvas holding the letterboxed 320×200
 * frame, and nothing else. Identical in shape to `Shell.tsx` — the difference
 * between `/`, `/missions` and `/career` is entirely which controller is
 * driving, which is the point of AD-009's layering.
 */

import { useNavigate } from "@solidjs/router";
import { createSignal, onCleanup, onMount, Show } from "solid-js";
import "./shell.css";
import { createScreenRuntime } from "./screen-runtime.ts";
import { observeViewMetrics } from "../three/view-metrics.ts";
export function ScreenShell(props) {
  const navigate = useNavigate();
  const runtime = createScreenRuntime(props.controller, navigate);
  const [status, setStatus] = createSignal(runtime.status());
  const [inset, setInset] = createSignal(undefined);
  runtime.subscribe(setStatus);
  runtime.onViewport(setInset);
  let canvas;
  function onKeyDown(event) {
    runtime.keyDown(event);
  }
  onMount(() => {
    runtime.mount(canvas);
    // Size **and** density: the shell's backing store is sized in device pixels
    // (`render/shell-surface.ts`), so a window dragged to a different-density
    // monitor has to repaint even though its CSS box never moved — and a bare
    // `ResizeObserver` does not fire for that (`three/view-metrics.ts`).
    const stopViewMetrics = canvas ? observeViewMetrics(canvas, () => runtime.refresh()) : undefined;
    window.addEventListener("keydown", onKeyDown);
    onCleanup(() => {
      stopViewMetrics?.();
      window.removeEventListener("keydown", onKeyDown);
      runtime.dispose();
    });
  });
  return (() => {
    var _el$ = _tmpl$3(),
      _el$2 = _el$.firstChild;
    _el$2.$$pointerdown = event => runtime.pointerDown(event);
    _el$2.$$pointermove = event => runtime.pointerMove(event);
    _$use(element => canvas = element, _el$2);
    _$insert(_el$, () => props.inset?.(inset), null);
    _$insert(_el$, () => props.overlay?.(), null);
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return status() === "loading";
      },
      get children() {
        return _tmpl$();
      }
    }), null);
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return status() === "failed";
      },
      get children() {
        return _tmpl$2();
      }
    }), null);
    _$effect(() => _$setAttribute(_el$2, "aria-label", props.label));
    return _el$;
  })();
}
_$delegateEvents(["pointermove", "pointerdown"]);